import React from "react";

interface StatusIndicatorProps {
  status: "active" | "waiting" | "closed" | string;
  showLabel?: boolean;
  size?: "sm" | "md" | "lg";
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  status,
  showLabel = true,
  size = "sm",
}) => {
  const getStatusColor = () => {
    switch (status) {
      case "active":
        return "bg-green-500";
      case "waiting":
        return "bg-yellow-500";
      case "closed":
        return "bg-gray-400";
      default:
        return "bg-gray-300";
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case "active":
        return "Active";
      case "waiting":
        return "Waiting";
      case "closed":
        return "Closed";
      default:
        return "Unknown";
    }
  };

  const getDotSize = () => {
    switch (size) {
      case "sm":
        return "w-2 h-2";
      case "md":
        return "w-3 h-3";
      case "lg":
        return "w-4 h-4";
      default:
        return "w-2 h-2";
    }
  };

  const getTextSize = () => {
    switch (size) {
      case "sm":
        return "text-xs";
      case "md":
        return "text-sm";
      case "lg":
        return "text-base";
      default:
        return "text-xs";
    }
  };

  if (!showLabel) {
    return (
      <div className={`${getDotSize()} rounded-full ${getStatusColor()}`} />
    );
  }

  return (
    <div className="flex items-center space-x-1">
      <div className={`${getDotSize()} rounded-full ${getStatusColor()}`} />
      <span className={`${getTextSize()} text-gray-500`}>
        {getStatusLabel()}
      </span>
    </div>
  );
};

export default StatusIndicator;
